import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import React, { useContext } from 'react';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';

import senslaLogo from 'assets/images/sensla-short-greyscale.png';
import { ctx, IStore } from '../../store';

import { useStyles } from './styles';

interface IProps {
  teams?: any;
  user: any;
}

const UserCard: React.FC<IProps> = ({ user, teams }) => {
  const history = useHistory();
  const classes = useStyles();
  const actions = useContext(ctx.actions);

  user = user;
  const navigateTo = async () => {
    await ((actions.teams.setCurrentTeam(
      filterTeam(),
      user.memberId
    ) as unknown) as Promise<IStore>);
    history.push(`/user-dashboard/pillars?memberId=${user.memberId}`);
  };

  const filterTeam = () => {
    if (teams.length) {
      if (user.team) {
        return teams.filter((item: any) => item.id === user.team)[0];
      } else {
        return teams.filter((item: any) => item.id === user.tenant)[0];
      }
    }
  };

  return (
    <Card className={classes.card}>
      <Grid className={classes.cardArea}>
        <CardActions className={classes.cardActions}>
          <Button
            className={classes.button}
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => navigateTo()}
          >
            <Typography className={classes.buttonText}>My Personal Dashboard</Typography>
          </Button>
        </CardActions>
        <CardContent className={classes.cardContent}>
          <Typography variant="h4" className={classes.teamName}>
            {`at ${teams && teams.length ? filterTeam().name : ''} workspace`}
          </Typography>
        </CardContent>
        {user.team && (
          <Grid className={classes.cardMedia}>
            <CardMedia
              className={classes.image}
              image={teams && teams.length ? filterTeam().avatar : senslaLogo}
            />
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export { UserCard };
